import { C } from '../constants';

export default function Glass({ children, style, onClick, className = '' }) {
  return (
    <div
      onClick={onClick}
      className={className}
      style={{
        background:          C.cardBg,
        border:              `1px solid ${C.border}`,
        borderRadius:        20,
        backdropFilter:      'blur(14px)',
        WebkitBackdropFilter:'blur(14px)',
        cursor:              onClick ? 'pointer' : undefined,
        transition:          'background 220ms ease, border-color 220ms ease, box-shadow 220ms ease',
        ...style,
      }}
    >
      {children}
    </div>
  );
}
